// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4m-1";
export var standaloneTable = "_4m-0";